export const getNegativeStockProducts = (products = []) => (
  (Array.isArray(products) ? products : [])
    .filter(product => product?.deleted !== true && product?.trackStock !== false)
    .filter(product => Number(product?.stock) < 0)
    .sort((left, right) => Number(left.stock) - Number(right.stock))
);
